import React from 'react';
import ReactDOM from 'react-dom/client';
import './GlobalFooter.css';

const GlobalFooter: React.FC = () => {
  return (
    <footer className="global-footer">
      <div>
        <div><a
            className="footer-link"
            href="https://github.com/rocinax"
            target="_blank"
            rel="noopener noreferrer"
            >Twitter</a></div>
        <div><a
            className="footer-link"
            href="https://github.com/rocinax"
            target="_blank"
            rel="noopener noreferrer"
            >Github</a>
        </div>
      </div>
    </footer>
  );
}

export default GlobalFooter;